import { Component, OnInit } from '@angular/core';
import { AuthService } from '../services/auth.service';

@Component({
  selector: 'app-user-notifications',
  templateUrl: './user-notifications.component.html',
  styleUrls: ['./user-notifications.component.css']
})
export class UserNotificationsComponent implements OnInit {

  allNotificaitons = [];

  constructor(
    private auth: AuthService
  ) { }

  ngOnInit() {
    this.getNotifications();
  }

  getNotifications() {
    this.auth.getUserNotifications(localStorage.getItem('usertype'), {}).subscribe(data => {
      this.allNotificaitons = data.data;
    }, error => {
    });
  }

  confirmClick() {
    document.getElementById('delete_confirm').click()
  }

  clearNotification() {
    let obj = {
      is_clear: true
    }
    this.auth.clearNotificaitons(localStorage.getItem('usertype'), obj).subscribe(data => {
      this.allNotificaitons = [];
      this.confirmClick();
    }, error => {
    });
  }

}
